const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://89xrhg5fzd.execute-api.ap-southeast-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://10vjdwnhjj.execute-api.ap-southeast-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://3wfo7v1z34.execute-api.ap-southeast-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.au.forwood.one'
  },
  configurationService: {
    URL: 'https://config.au.forwood.one',
    WEBSOCKET: 'wss://l2a5ttj1n4.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;